module.exports = __webpack_public_path__ + "static/media/unlike-icon-filled.bed706e7.svg";